import Vue from 'vue';
import gql from 'graphql-tag';

export default {
    namespaced: true,
    state: {
        loading: false,
        redirectUrl: null,
    },
    mutations: {
        setLoading(state, value) {
            state.loading = value;
        },
    },
    actions: {
        createPayment({ commit }, options) {
            Vue.$store.commit('Payment/setError', null);
            commit('setLoading', true);
            return Vue.$graphql
                .mutate({
                    mutation: gql`
                        mutation payeverCreatePayment($orderId: Int!, $transactionId: String!) {
                            payeverCreatePayment(orderId: $orderId, transactionId: $transactionId) {
                                success
                                redirectUrl
                            }
                        }
                    `,
                    variables: {
                        orderId: parseInt(options.orderId),
                        transactionId: options.transactionId,
                    },
                })
                .then(r => r.data)
                .then(data => {
                    let result = data.payeverCreatePayment;
                    if (result && result.redirectUrl) {
                        window.location.href = result.redirectUrl;
                    }
                })
                .catch(error => {
                    if (error.message) {
                        Vue.$store.commit('Payment/setError', error.message);
                    }
                    commit('setLoading', false);
                });
        },
        executePayment({ commit }, options) {
            Vue.$store.commit('Payment/setError', null);
            commit('setLoading', true);
            return Vue.$graphql
                .mutate({
                    mutation: gql`
                        mutation payeverExecutePayment($orderId: Int!, $transactionId: String!, $paymentId: String!) {
                            payeverExecutePayment(
                                orderId: $orderId
                                transactionId: $transactionId
                                paymentId: $paymentId
                            ) {
                                success
                                status
                            }
                        }
                    `,
                    variables: {
                        orderId: parseInt(options.orderId),
                        transactionId: options.transactionId,
                        paymentId: options.paymentId,
                    },
                })
                .then(r => r.data)
                .then(data => {
                    if (!data.success) {
                        commit('setLoading', false);
                        return data.payeverExecutePayment;
                    }
                    commit('setLoading', false);
                    return data.payeverExecutePayment;
                })
                .catch(error => {
                    if (error.message) {
                        Vue.$store.commit('Payment/setError', error.message);
                    }
                    commit('setLoading', false);
                });
        },
    },
};
